import React from 'react';


export default class MMII extends React.Component{
  constructor(props) {
    super(props);

    this.state = {

    };

  }

  render(){
    const strings = this.state.strings;
    const video = '293121637';
    return(
      <div>
        <div>Neste vídeo temos um exemplo de treino de pernas completo, para que você possa visualizar melhor como treinamos do Foco90:</div>
          <iframe
            className='vimeo-video'
            src={`https://player.vimeo.com/video/${video}?autoplay=1&loop=1&autopause=0`}
            height="300"
            frameBorder="0"
            webkitallowfullscreen="true"
            mozallowfullscreen="true"
            allowFullScreen="true">
          </iframe>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/tecnicas/MMII.js